'use strict';

import {
    RECEIVE_PROJECT_FILES,
} from './actions.js';

export default (state = {
    files: [],  // uploaded files; results from CompletedFileUpload
}, action) => {
    switch (action.type) {
        case RECEIVE_PROJECT_FILES:
            return {
                ...state,
                files: action.files,
            }        
            
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/project/project-files/state/reducer.js